let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1pebU")).then(() => parcelRequire('6pwND'));